export const DEFAULT_PRIVACY_NOTICE_TEXT =
  'This chat is automated. We collect information to help us assist you better.';

export const PRIVACY_NOTICE_TEXT_MAX_LENGTH = 200;
